import Vue from 'vue';
import VueRouter from 'vue-router';
import { dashboard } from '@/routes/dashboard';
import store from '@/store';
import { Pipeline } from 'vue-router-guards';
import { AuthGuard } from '@/routes/guards/AuthGuard';
import { NotFoundGuard } from '@/routes/guards/NotFoundGuard';
import { PermissionGuard } from '@/routes/guards/PermissionGuard';
import { dev } from '@/routes/dev';

Vue.use(VueRouter);

type ImportedComponent = typeof import('*.vue');

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'index',
      redirect: '/login'
    },
    {
      path: '/dashboard',
      component: (): Promise<ImportedComponent> =>
        import(/* webpackChunkName: "dashboard.layout" */ '@/layouts/dashboard/Dashboard.vue'),
      children: [
        ...dashboard.map((route) => ({ ...route, path: '/dashboard' + route.path }))
      ],
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: (): Promise<ImportedComponent> =>
        import(/* webpackChunkName: "dashboard.login" */ '@/views/Login.vue'),
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '*',
      name: 'notFound',
      component: (): Promise<ImportedComponent> =>
        import(/* webpackChunkName: "views.NotFound" */ '@/views/NotFound.vue')
    },
    ...dev.map((route) => ({ ...route, path: '/dev' + route.path }))
  ]
});

const pipeline = new Pipeline();

pipeline.use(new NotFoundGuard());
pipeline.use(new AuthGuard());
pipeline.use(new PermissionGuard(store));

router.beforeEach(pipeline.execute.bind(pipeline));

router.onError((e) => {
  console.error(e);
  store.commit('app/errors/add', e.message);
});

export default router;
